import { render, staticRenderFns } from "./passenger.vue?vue&type=template&id=2900c7b4&scoped=true&"
import script from "./passenger.vue?vue&type=script&lang=js&"
export * from "./passenger.vue?vue&type=script&lang=js&"
import style0 from "./passenger.vue?vue&type=style&index=0&id=2900c7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900c7b4",
  null
  
)

export default component.exports